var map = {
	"./ar.json": [
		61925,
		[
			1925
		]
	],
	"./bn.json": [
		64118,
		[
			4118
		]
	],
	"./el.json": [
		52539,
		[
			2539
		]
	],
	"./en.json": [
		88053,
		[
			8053
		]
	],
	"./es.json": [
		81406,
		[
			1406
		]
	],
	"./fa.json": [
		16807,
		[
			6807
		]
	],
	"./fr.json": [
		47222,
		[
			7222
		]
	],
	"./hi.json": [
		29249,
		[
			9249
		]
	],
	"./id.json": [
		43999,
		[
			3999
		]
	],
	"./it.json": [
		78767,
		[
			8767
		]
	],
	"./items/en.json": [
		5596,
		[
			5596
		]
	],
	"./items/es.json": [
		5355,
		[
			5355
		]
	],
	"./items/fr.json": [
		67015,
		[
			7015
		]
	],
	"./items/zh.json": [
		82093,
		[
			2093
		]
	],
	"./ja.json": [
		67083,
		[
			7083
		]
	],
	"./ko.json": [
		73948,
		[
			3948
		]
	],
	"./languageLearning/en.json": [
		32248,
		[
			2248
		]
	],
	"./languageLearning/zh.json": [
		22825,
		[
			2825
		]
	],
	"./ms.json": [
		31702,
		[
			1702
		]
	],
	"./my.json": [
		89964,
		[
			9964
		]
	],
	"./openbadge/en.json": [
		84629,
		[
			4629
		]
	],
	"./openbadge/zh.json": [
		63744,
		[
			3744
		]
	],
	"./pt.json": [
		15034,
		[
			5034
		]
	],
	"./ru.json": [
		58335,
		[
			8335
		]
	],
	"./school/en.json": [
		62796,
		[
			2796
		]
	],
	"./school/zh.json": [
		43613,
		[
			3613
		]
	],
	"./studioMusicians/en.json": [
		54876,
		[
			4876
		]
	],
	"./studioMusicians/zh.json": [
		56237,
		[
			6237
		]
	],
	"./studioPlayers/en.json": [
		85360,
		[
			5360
		]
	],
	"./studioPlayers/zh.json": [
		76465,
		[
			6465
		]
	],
	"./ta.json": [
		37989,
		[
			7989
		]
	],
	"./th.json": [
		75074,
		[
			5074
		]
	],
	"./tr.json": [
		203,
		[
			2584
		]
	],
	"./ur.json": [
		71785,
		[
			1785
		]
	],
	"./vi.json": [
		25759,
		[
			5759
		]
	],
	"./zh.json": [
		50816,
		[
			816
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(() => {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 8631;
module.exports = webpackAsyncContext;